import React, { Fragment, useState } from 'react';
import Header3 from '../../components/header3/Header3';
import Scrollbar from '../../components/scrollbar/scrollbar'
import ServiceHero from '../../components/hero3/servicehero';
import BusinessContact from '../../components/business-consulting-components/BusinessContact/BusinessContact';
import BusinessFooter from '../../components/business-consulting-components/BusinessFooter/BusinessFooter';
import Video from '../../images/Video.png';
import aiseo from '../../images/aiseo.png';
import Whatit from '../../components/business-consulting-components/Whatit';
import Faq from '../../components/business-consulting-components/Faq';
import ProjectShowcaseSlider from '../../components/business-consulting-components/Project';
import TestimonialsSection from '../../components/business-consulting-components/TestimonialsSection';
import ToolSection from '../../components/business-consulting-components/ToolSection';
import ProcessSection from '../../components/business-consulting-components/ProcessSection';

const SaasAiSeo = (props) => {

    const [isOpen, setOpen] = useState(false)
    return (
        <Fragment>
           <div className='index_business_consulting seo_type'>
                <main className="page_content s2">
                    <Header3 />
                    <ServiceHero top_title={<>AI SEO Agency for SaaS: <br/> AEO + GEO That Grow MRR</>} top_desp={<>Turn high-intent searches; on Google and AI assistants—into signups, <br/> demos, and revenue. </>} />

                    <section className="video_section">
                        <div className="container text-center">
                             <img src={Video} alt="Video" className='video_img'/>
                        </div>
                    </section>

                    <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-6">
                                    <span class="sub_heading">WHY SAAS AI SEO</span>
                                    <br/>
                                    <br/>
                                    <div class="heading_block">
                                        <h2 class="heading_text">Your AI SEO Partner</h2>
                                        <p class="heading_description text-dark pe-lg-5">Most “classic” SEO isn’t built for SaaS buying behavior.</p>
                                        <ul class="saasai_list mt-4 heading_description">
                                            <li><i class="fa fa-times check_icon_new" aria-hidden="true"></i>Unable to map the target user intent into the content and pages</li>
                                            <li><i class="fa fa-times check_icon_new" aria-hidden="true"></i>Weak entity signals mean LLMs skip citing your brand in answers</li>
                                            <li><i class="fa fa-times check_icon_new" aria-hidden="true"></i>Underdeveloped funnel pages leave money on the table</li>
                                            <li><i class="fa fa-times check_icon_new" aria-hidden="true"></i>Slow content ops can’t keep up with industry & product</li>
                                            <li><i class="fa fa-times check_icon_new" aria-hidden="true"></i>No coverage for AEO/GEO (Answer & Generative Engine Optimization)</li>
                                        </ul>
                                    </div>

                                    <button className="read_more btn btn-secondary" style={{marginLeft:'0px'}}>Contact Now</button>

                                </div>
                                <div className="col-lg-6">
                                    <img src={aiseo} alt="aiseo" className='img-fluid'/>
                                </div>
                            </div>
                        </div>
                    </section>
                    <Whatit />
                    <Faq />
                    <ProjectShowcaseSlider />
                    <ProcessSection/>
                    <ToolSection title1={<><b>Free Tool: </b> AEO Visibility Scorecard</>} title2={<>See where your SaaS is (and isn’t) mentioned in AI answers plus the fastest fixes.</>} />
                    <TestimonialsSection />
                    <BusinessContact />
                    <BusinessFooter />
                    <Scrollbar />
                </main>
            </div>
        </Fragment>
    )
};
export default SaasAiSeo;
